module.exports = __webpack_public_path__ + "static/media/portfolio-balance.01ab22ea.png";